import { Text, Tooltip } from '@mantine/core'

export type Outcome = 'success' | 'failure' | 'denied'

const ICON: Record<Outcome, string> = {
  success: '✓',
  failure: '✕',
  denied: '⊘',
}
const COLOR: Record<Outcome, string> = {
  success: 'green',
  failure: 'red',
  denied: 'orange',
}

export function OutcomeIcon({ outcome }: { outcome?: Outcome }) {
  const o = outcome ?? 'success'
  return (
    <Tooltip label={o} withArrow>
      <Text size="sm" c={COLOR[o]} fw={700}>{ICON[o]}</Text>
    </Tooltip>
  )
}
